export default "https://assets.egbcdn.net/assets/packs/_/sounds/poker/new_call-0db41932dc6cd995c893b276dd274299.mp3";